import React, { useEffect } from 'react'
// @ts-ignore no types
import {
  CardContainer,
  Button,
  Badge,
  Text,
  constants,
  ProgressTimeline,
} from '@adc/ui-adc'
import * as blueprint from '@adc/blueprint'
import { useListingContext } from 'common/context/listing'
import classnames from 'classnames/bind'
import moment from 'moment'
import analytics from 'common/services/analytics'
// @ts-ignore no types
import cls from './styles.scss'

const cx = classnames.bind(cls)

const TBD = 'TBD'

export const ListingSelectorComponent = () => {
  const { listing, activeListings, listingActions } = useListingContext()

  // The following useEffect is here to allow to navigate back to the previous asset when clicking the Back button in the browser
  useEffect(() => {
    const handleUrlChange = () => {
      const currentUrl = window.location.href
      const currentListingId = currentUrl.split('-').pop()
      if (
        currentListingId &&
        currentListingId !== listing?.listing_id &&
        activeListings?.find(listing => listing.listing_id === currentListingId)
      ) {
        listingActions?.setCurrentListingId(currentListingId)
      }
    }

    window.addEventListener('popstate', handleUrlChange)

    return () => {
      window.removeEventListener('popstate', handleUrlChange)
    }
  }, [activeListings, listing, listingActions])

  const fclListing = activeListings?.find(
    listing => listing?.event?.trustee_sale
  )
  const isCurrentListingFCL = fclListing?.listing_id === listing?.listing_id
  const privateSellerListing = activeListings?.find(listing =>
    blueprint.listing.utils.isPrivateSeller(listing)
  )

  const areBothListingsAvailable = fclListing && privateSellerListing

  const toggleListing = () => {
    const targetListing = activeListings?.find(
      ({ listing_id }) => listing_id !== listing?.listing_id
    )
    if (targetListing) {
      analytics.privateSeller.buyNowTabClick()
      const currentUrl = window.location.href
      const targetUrl = currentUrl?.replace(
        listing?.listing_id,
        targetListing.listing_id
      )
      listingActions?.setCurrentListingId(targetListing.listing_id)
      history.pushState({}, '', targetUrl)
    }
  }

  if (!areBothListingsAvailable || !isCurrentListingFCL) {
    return null
  }

  const elmId = 'listing-selector'

  const markerLabel = (days: number) => {
    if (listing.auction?.auction_date) {
      return `${days} Day${days > 1 ? 's' : ''} to Auction`
    }
    return TBD
  }

  return (
    <div className={cx('tabs-container')} data-elm-id={elmId}>
      <div className={cx('tab-section')}>
        <div className={cx('main-tab')}>
          <CardContainer
            padding='medium'
            borderStyle='gradient'
            borderColor={constants.ColorNames.AdcLightGreen}
            borderRadius='medium'
            borderRadiusCorners='top'
            dropShadow='none'
            backgroundColor={constants.ColorNames.White}
          >
            <Text
              color='adcLightGreen'
              size='small'
              weight='heavy'
              elmId={`${elmId}_current-mode-title`}
            >
              Buy at Foreclosure
            </Text>
          </CardContainer>
        </div>
        <div className={cx('secondary-tab')}>
          <CardContainer padding='none'>
            <Button
              role='tertiary'
              color={constants.ColorNames.Purple}
              onClick={toggleListing}
              elmId={`${elmId}_toggle-mode-button`}
            >
              Buy Now <Badge mode='purple' primary='New!' size='small' />
            </Button>
          </CardContainer>
          <div className={cx('divider')} />
        </div>
      </div>
      <div className={cx('progress-section')}>
        <ProgressTimeline
          leftLabel='Pre-Foreclosure'
          rightLabel='Foreclosure Sale'
          markerLabel={markerLabel}
          accentColor={constants.ColorNames.Purple}
          startDate={moment(
            listing.primary_property.first_activation_date
          ).toDate()}
          endDate={
            moment(listing.auction?.auction_date).toDate() || moment().toDate()
          }
          endedLabel={
            listing.auction?.auction_date ? 'Auction in Progress' : TBD
          }
        />
      </div>
    </div>
  )
}

export default ListingSelectorComponent
